import {
    createRouter,
    createWebHistory
} from 'vue-router'

// 导入页面组件
import Login from '../views/login.vue'
import Callback from '../views/callback.vue'
import Workbench from '../views/Workbench.vue'
import Customer from '../views/Customer.vue'
import Live from '../views/Live.vue'
import Myindex from '../views/myindex.vue'
import InviteCustomers from '../views/Invitecustomers/Invitecustomers.vue'
import WriteOff from '../views/write-off/write-off.vue'
import WriteOffOrder from '../views/write-off/write-off-order.vue'
import OrderWrite from '../views/write-off/orderwrite.vue'
import WriteOffCoupon from '../views/write-off/write-off-coupon.vue'
import ShopCheckIn from '../views/shopcheckin/shopcheckin.vue'
import CheckInStatus from '../views/shopcheckin/checkinstatus.vue'
import OrderList from '../views/orderlist/orderlist.vue'
import OrderDetails from '../views/orderlist/orderdetails.vue'
import MyDepartments from '../views/myDepartments/myDepartments.vue'
import CustomerBirthday from '../views/operation/CustomerBirthday.vue'
import StoreCart from '../views/store_view/store_cart.vue'
import StoreOrder from '../views/store_view/store_order.vue'
import StoreShopList from '../views/store_view/store_shop_list.vue'
import StoreConfirm from '../views/store_view/store_confirm.vue'
import StoreOrderDetail from '../views/store_view/store_order_detail.vue'
import StoreShipment from '../views/store_view/store_shipment.vue'
import OrderShipment from '../views/orderlist/ordershipment.vue'
import CustomerList from '../views/customer/customerList.vue'
import CustomerDetail from '../views/customer/customerDetail.vue'
import CustomerTagsEdit from '../views/customer/customerTagsEdit.vue'
import PointBill from '../views/customer/pointBill.vue'
import LiveDetail from '../views/live/liveDetail/index.vue'
import Activity from '../views/activity/activity.vue'
import ActivityInfo from '../views/activity/activityInfo.vue'
import ActivityAdd from '../views/activity/activityAdd.vue'
import ActivityCoupon from '../views/activity/activityCoupon.vue'
import SelActivity from '../views/activity/selActivity.vue'
import MyTeam from '../views/myTeam/myTeam.vue'
import OperateMember from '../views/myTeam/operateMember.vue'
import TransformCustomer from '../views/transformCustomer/transformCustomer.vue'
import SelectManager from '../views/transformCustomer/selectManager.vue'
import ClosingBooks from '../views/closingBooks/closingBooks.vue'
import BuyerProxyPayment from '../views/BuyerProxyPayment/BuyerProxyPayment.vue'
import CreateCustomer from '../views/BuyerProxyPayment/createCustomer.vue'
import CreateCustomerSuc from '../views/BuyerProxyPayment/createCustomerSuc.vue'
import TakeOrderType from '../views/BuyerProxyPayment/takeOrderType.vue'
import StoreShopDetail from '../views/store_view/store_shop_detail.vue'

// 定义路由规则
const routes = [{
        path: '/',
        redirect: '/workbench'
    },
    {
        path: '/login',
        name: '登录',
        component: Login
    },
    {
        path: '/callback',
        name: '登录回调',
        component: Callback

    },
    {
        path: '/workbench',
        name: '工作台',
        component: Workbench
    },

    // 我的客户
    {
        path: '/customer',
        name: '客户',
        component: Customer
    },
    {
        path: '/customerList',
        name: '我的客户',
        component: CustomerList
    },
    {
        path: '/customerDetail',
        name: '客户详情',
        component: CustomerDetail
    },
    {
        path: '/customerTagsEdit',
        name: '编辑客户标签',
        component: CustomerTagsEdit
    },
    {
        path: '/pointBill',
        name: '积分账单',
        component: PointBill
    },

    // 直播相关
    {
        path: '/live',
        name: '直播',
        component: Live
    },
    {
        path: '/liveDetail',
        name: '直播详情',
        component: LiveDetail
    },
    // 活动
    {
        path: '/activity',
        name: '活动',
        component: Activity
    },
    {
        path: '/activityInfo',
        name: '活动详情',
        component: ActivityInfo
    },
    {
        path: '/activityAdd',
        name: '创建活动',
        component: ActivityAdd
    },
    {
        path: '/activityCoupon',
        name: '优惠券',
        component: ActivityCoupon
    },
    {
        path: "/selActivity",
        name: '选择活动',
        component: SelActivity
    },
    // 我的团队
    {
        path: '/myTeam',
        name: '我的团队',
        component: MyTeam
    },
    {
        path: '/operateMember',
        name: '成员管理',
        component: OperateMember
    },
    // 客户转移
    {
        path: '/transformCustomer',
        name: '客户转移',
        component: TransformCustomer
    },
    {
        path: '/selectManager',
        name: '选负责人',
        component: SelectManager
    },
    // 关账记录
    {

        path: '/closingBooks',
        name: '关账记录',
        component: ClosingBooks
    },
    {
        path: '/myindex',
        name: '我的',
        component: Myindex
    },
    {
        path: '/invite-customers',
        name: '邀请客户',
        component: InviteCustomers
    },
    {
        path: '/write-off',
        name: '核销',
        component: WriteOff
    },
    {
        path: '/write-off-order',
        name: '核销订单提货',
        component: WriteOffOrder
    },
    {
        path: '/orderwrite',
        name: '核销订单',
        component: OrderWrite
    },
    {
        path: '/write-off-coupon',
        name: '核销优惠券',
        component: WriteOffCoupon
    },
    {
        path: '/shopcheckin',
        name: '门店签到',
        component: ShopCheckIn
    },
    {
        path: '/checkinstatus',
        name: '签到状态',
        component: CheckInStatus
    },
    {
        path: '/orderlist',
        name: '订单列表',
        component: OrderList


    },
    {
        path: '/orderdetails',
        name: '订单详情',
        component: OrderDetails

    },
    {
        path: '/ordershipment',
        name: '商品发货',
        component: OrderShipment

    },
    {
        path: '/myDepartments',
        name: '我的部门',
        component: MyDepartments

    },
    {
        path: '/customer-birthday',
        name: '客户生日',
        component: CustomerBirthday

    },
    {
        path: '/store_cart',
        name: '门店购物车',
        component: StoreCart
    },
    {
        path: '/store_order',
        name: '门店订单',
        component: StoreOrder
    },
    {
        path: '/store_shop_list',
        name: '门店进货',
        component: StoreShopList
    },
    {
        path: '/store_shop_detail',
        name: '商品详情',
        component: StoreShopDetail
    },
    {
        path: '/store_confirm',
        name: '门店订单确认',
        component: StoreConfirm
    },
    {
        path: '/store_order_detail',
        name: '进货订单详情',
        component: StoreOrderDetail
    },
    {
        path: '/store_shipment',
        name: '包裹列表',
        component: StoreShipment
    },
    //  代客下单
    {
        path: '/BuyerProxyPayment',
        name: '代客下单',
        component: BuyerProxyPayment

    },
    {
        path: '/createCustomer',
        name: '添加客户',
        component: CreateCustomer

    },
    {
        path: '/createCustomerSuc',
        name: '添加客户成功',
        component: CreateCustomerSuc

    },
    {
        path: '/takeOrderType',
        name: '下单模式',
        component: TakeOrderType

    }
]

// 创建路由实例
const router = createRouter({
    history: createWebHistory(),
    routes
})

// 添加路由守卫，动态设置页面标题
router.beforeEach((to, from, next) => {
    // 设置页面标题为当前路由的name
    document.title = to.name || '食养集'
    next()
})

export default router